import { render, staticRenderFns } from "./grantUse.vue?vue&type=template&id=1ec3506a&scoped=true"
import script from "./grantUse.vue?vue&type=script&lang=js"
export * from "./grantUse.vue?vue&type=script&lang=js"
import style0 from "./grantUse.vue?vue&type=style&index=0&id=1ec3506a&prod&lang=scss&scoped=true"
import style1 from "./grantUse.vue?vue&type=style&index=1&id=1ec3506a&prod&lang=scss&scoped=true"
import style2 from "./grantUse.vue?vue&type=style&index=2&id=1ec3506a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3506a",
  null
  
)

export default component.exports